/* eslint-disable react/prop-types */
import React from 'react';
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import 'react-bootstrap-table/css/react-bootstrap-table.css';
import '../css/Warehouse.css';
import { Route, Switch } from 'react-router-dom';
import FormAddModule from './FormAddModule';
import ListModule from './ListModule';
import MyUtil from '../../functions/MyUtil';

const Module = ({ match }) => {
  return (
    <div>
      <Switch>
        {MyUtil.hasPermission(match.url, 'view') && (
          <Route
            exact
            path={`${match.url}`}
            component={() => <ListModule match_parent={match} />}
          />
        )}
        {MyUtil.hasPermission(match.url, 'add') && (
          <Route path={`${match.url}/add`} component={FormAddModule} />
        )}
        {MyUtil.hasPermission(match.url, 'update') && (
          <Route
            path={`${match.url}/edit/:module_id`}
            component={FormAddModule}
          />
        )}
      </Switch>
    </div>
  );
};

export default Module;
